import PropTypes from "prop-types";
import "./PageStructure.scss";

const PageWrapper = ({ children }) => {
  return (
    <div className="page-container-wrapper">
      <div className="page-container">{children}</div>
    </div>
  );
};

PageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PageWrapper;
